export default "__VITE_ASSET__NzID5Dft__"